import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DropdownAnswer from '../../Answer/DropdownAnswer';

import styles from './styles.module.scss';

const DropdownQuestion = ({ number, stage, question, activeQuestion, setSelectedAnswer, disabled }) => {
  const { t } = useTranslation();
  const [openDropdown, setOpenDropdown] = useState(false);

  const selectedAnswer = (question, item) => {
    setSelectedAnswer(question, item);
    setOpenDropdown(false);
  };

  return <div className={styles.question + ' ' + (question.answer ? styles.complete : disabled ? styles.disabled : '') + ' ' + (number === activeQuestion ? styles.active : '')}>
    <h3 className={styles.title}>
      {t(`tool_ui.${stage.key}.${question.key}`)}
    </h3>
    <div onClick={() => setOpenDropdown(!openDropdown)} className={styles.answer + ' ' + (openDropdown ? styles.answer_open : '')}>
      {question.answer ? t(question.answer.text) : t(`tool_ui.global.field_default`)}
      <div className={styles.answers + ' ' + (openDropdown ? styles.answers_open : '')}>
        {question.choices.map((answer, index) => <DropdownAnswer
          key={index}
          question={question}
          item={answer}
          setSelectedAnswer={selectedAnswer}
          disabled={disabled}
        />)}
      </div>
    </div>
  </div>;
}

export default DropdownQuestion;
